module.exports = __webpack_public_path__ + "static/media/affi_dropdown.c624fcff.svg";